import type { EmbedContext, ResolvedAttribution } from "./types.js";

const trackedImpressions = new WeakSet<HTMLElement>();

export function buildPayload(
  type: "impression" | "click",
  formId: string,
  embed: EmbedContext,
  attribution: ResolvedAttribution
) {
  return {
    type,
    formId,
    campaignId: attribution.campaignId,
    campaignSlug: attribution.campaignSlug,
    utm: attribution.utm,
    referrer: embed.referrer,
    metadata: {
      hostname: embed.hostname,
      pageUrl: embed.pageUrl,
      pageTitle: embed.pageTitle,
      screenWidth: embed.screenWidth,
      ...attribution.metadata,
    },
  };
}

export function trackImpression(
  embedApiUrl: string,
  formId: string,
  embed: EmbedContext,
  attribution: ResolvedAttribution,
  hostEl: HTMLElement
): void {
  if (trackedImpressions.has(hostEl)) return;
  trackedImpressions.add(hostEl);

  fetch(`${embedApiUrl}/api/fi`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "omit",
    keepalive: true,
    body: JSON.stringify(buildPayload("impression", formId, embed, attribution)),
  }).catch(() => {});
}

export function trackClick(
  embedApiUrl: string,
  formId: string,
  embed: EmbedContext,
  attribution: ResolvedAttribution
): void {
  fetch(`${embedApiUrl}/api/fi`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "omit",
    keepalive: true,
    body: JSON.stringify(buildPayload("click", formId, embed, attribution)),
  }).catch(() => {});
}
